/*
 * Footer Messages
 *
 * This contains all the text for the Footer component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  discoverTitle: {
    id: 'discover.title',
    defaultMessage: 'Ontdek'
  },
  resultTitle: {
    id: 'result.title',
    defaultMessage: 'Resultaat'
  },
  resultIntro: {
    id: 'result.intro',
    defaultMessage:
      'Ipsum dictum lacus sollicitudin quisque eros nam fringilla condimentum hendrerit sagittis viverra nunc lorem volutpat, convallis phasellus porttitor neque euismod ante class sapien ut mollis augue donec maecenas.'
  },
  discoverQuestionnaireDescription: {
    id: 'discover.questionnaire.description',
    defaultMessage: 'Vul de vragenlijst in en ontdek jouw motiverende lesgeefstijl. Op het einde van de vragenlijst krijg je jouw gepersonaliseerd profiel te zien. Met dit profiel kan je aan de slag in ‘stap 2’.'
  },
  discoverQuestionnaire: {
    id: 'discover.questionnaire',
    defaultMessage: 'Ontdek je motiverende lesgeefstijl'
  },
  discoverResultDescription: {
    id: 'discover.result.description',
    defaultMessage: 'Hier kan je jouw gepersonaliseerd profiel terugvinden. Let wel op: je kan enkel jouw meest recente gepersonaliseerd profiel zien (van de laatste keer dat je de vragenlijst invulde).'
  },
  discoverResult: {
    id: 'discover.result',
    defaultMessage: 'Raadpleeg jouw gepersonaliseerd profiel'
  }
});
